import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Text';
import { Link } from 'components/core/Link';
import { StarReview } from 'components/review/StarReview';

export default function FacilityReviewSummary({
	rating,
	facilityUrl,
	reviewCount,
	starSize,
	noFollowFacilityLink,
	className,
	showRating,
	color,
	plainText
}) {
	return (
		<StarReview
			labelSize="tiny"
			reviewCount={reviewCount}
			rating={rating}
			showOutOf={false}
			starSize={starSize}
			className={className}
			showRating={showRating}
			color={color}
			labelComponent={({ labelSize, label }) => (plainText ?
				(
					<Text
						size="standard"
						weight="ultraBold"
					>
						{label}
					</Text>
				) :
				(
					<Text
						size={labelSize}
						strong
						className="review-count"
					>
						<Link
							href={`${facilityUrl}#reviews`}
							rel={noFollowFacilityLink ? 'nofollow' : ''}
							productClick
						>
							{label}
						</Link>
					</Text>
				))}
		/>
	);
}

FacilityReviewSummary.propTypes = {
	reviewCount: PropTypes.number,
	rating: PropTypes.number,
	facilityUrl: PropTypes.string,
	starSize: PropTypes.string,
	noFollowFacilityLink: PropTypes.bool,
	className: PropTypes.string,
	showRating: PropTypes.bool,
	color: PropTypes.string,
	plainText: PropTypes.bool
};

FacilityReviewSummary.defaultProps = {
	starSize: 'small'
};
